import API from './api';

// Quant Engine — single service file mirroring hfService.js / tradingService.js patterns.
// All endpoints assume the user has trading access (TradingAccess permission server-side).

export const quantService = {
  // ─── Health
  health: () => API.get('/api/quant/health/'),

  // ─── Universe
  listUniverses:        ()              => API.get('/api/quant/universes/'),
  createUniverse:       (body)          => API.post('/api/quant/universes/', body),
  getUniverse:          (id)            => API.get(`/api/quant/universes/${id}/`),
  getMembership:        (id, asOfDate)  => API.get(
    `/api/quant/universes/${id}/membership/${asOfDate ? `?date=${asOfDate}` : ''}`
  ),
  refreshUniverse:      (id)            => API.post(`/api/quant/universes/${id}/refresh/`),

  // ─── Data quality
  getDataQuality:       (params = {})   => API.get('/api/quant/data-quality/', { params }),

  // ─── Discovery
  runDiscovery:         (body)          => API.post('/api/quant/discovery/run/', body),
  listDiscovery:        ()              => API.get('/api/quant/discovery/'),
  getDiscovery:         (jobId)         => API.get(`/api/quant/discovery/${jobId}/`),
  cancelDiscovery:      (jobId)         => API.post(`/api/quant/discovery/${jobId}/cancel/`),
  resumeDiscovery:      (jobId)         => API.post(`/api/quant/discovery/${jobId}/resume/`),
  startFreshDiscovery:  (jobId)         => API.post(`/api/quant/discovery/${jobId}/start-fresh/`),
  runAlphalens:         (jobId)         => API.post(`/api/quant/discovery/${jobId}/alphalens/`),
  getTrials:            (jobId)         => API.get(`/api/quant/discovery/${jobId}/trials/`),

  // ─── Backtest
  runBacktest:          (body)          => API.post('/api/quant/backtest/run/', body),
  listBacktest:         ()              => API.get('/api/quant/backtest/'),
  getBacktest:          (jobId)         => API.get(`/api/quant/backtest/${jobId}/`),

  // ─── Monitoring
  getICTimeseries:      (jobId)         => API.get(`/api/quant/monitoring/${jobId}/ic/`),

  // ─── Worker introspection
  getWorkerStatus:      ()              => API.get('/api/quant/infra/worker-status/'),
  // Durable spot-worker audit ledger (System tab): current + history.
  getSpotWorkers:       (limit = 50)    => API.get('/api/quant/infra/spot-workers/', { params: { limit } }),
};

export default quantService;
